import { isEmpty, isNil } from 'lodash'

// NOTE:
// あんまり!をつけるのが好きじゃなので薄くラップする
// 微妙そうならやめる
export const isNotEmpty = (value: any): boolean => !isEmpty(value)
export const isNotNil = (value: any): boolean => !isNil(value)
